<template>
  <el-card>
    <div
        slot="header"
        class="clearfix">
      <span class="header-item">Push Notification Data</span>
    </div>
    <div
        class="card-content">
      <div v-if="status === 'not-loading'">
        <div style="text-align: center; margin: 40px;">
          <a
              class="el-button el-button--primary"
              @click="loadLogs()">
            Load Push Notification Logs <i class="el-icon-download"></i>
          </a>
          <div style="text-align: center">
            <small>This request may take a while</small>
          </div>
        </div>
      </div>
      <div
          v-if="status === 'loading'"
          class="message">
        <div style="text-align: center; margin: 40px;">
          Loading Push Notification Logs. Please stay at this page without reloading it. <i class="el-icon-loading">
          </i>
        </div>
      </div>
      <div v-if="status === 'loaded'">
        <div
            v-if="pnsData.length < 1"
            class="message">
          Push notifications not found for this event.
        </div>
        <div v-if="pnsData.length > 0">
          <div
              v-for="row in pnsData"
              :key="row">
            <el-card
                v-for="meta in row.metadata"
                :key="meta"
                class="box-card">
              <ul>
                <li
                    v-for="(key, value) in meta"
                    :key="key">
                  <strong>{{ value }}: </strong>{{ key }}
                </li>
              </ul>
            </el-card>
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions: eventActions } = createNamespacedHelpers("event");
const { mapGetters } = createNamespacedHelpers("db/device");
export default {
  name: "EventPns",
  props: {
    eventId: { type: [String, Number], required: true },
  },
  data() {
    return {
      status: "not-loading",
      pnsData: [],
    };
  },
  computed: {
    ...mapGetters(["device"]),
  },
  channels: {
    PushNotificationLogsChannel: {
      connected() {
        console.info("Connected to PNS channel");
      },
      rejected() {
        console.errr("Error connecting to PNS channel");
      },
      received(response) {
        console.log("Data received", response.data);
        this.status = "loaded";
        this.pnsData = response.data;
      },
      disconnected() {
        console.info("Disconnected from PNS channel");
      },
    },
  },
  mounted() {
    this.connectWithRefreshedToken();
  },
  methods: {
    ...eventActions(["getPnsLogsData"]),
    connectWithRefreshedToken() {
      const token = localStorage.getItem("@token_id");
      this.$cable.connection.connect(
        `wss://${new URL(process.env.API_URL).host}/cable?token=${token}`
      );
    },
    subscribeToPnsChannel() {
      this.$cable.subscribe({
        channel: `PushNotificationLogsChannel`,
        ding_id: this.eventId,
      });
    },
    loadLogs() {
      this.status = "loading";
      this.subscribeToPnsChannel();
      this.getPnsLogsData({
        eventId: this.eventId,
        userId: this.device.owner_id,
      })
        .then((response) => {
          this.pnsData = "Loading Push Notification Data Please Wait Here.";
        })
        .catch((error) => {
          this.$notify.error({
            title: "Pns Logs",
            message: error.data.message,
          });
          console.log("Error loading Push Notification Logs", error);
        });
    },
  },
};
</script>
